// React import not required with the new JSX transform
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Welcome } from './screens/Welcome/Welcome';
import { WhoIsThisFor } from './screens/WhoIsThisFor/WhoIsThisFor';
import { HelpTypeScreen } from './screens/HelpType/HelpType';
import { ConcernsScreen } from './screens/Concerns/Concerns';
import { OptionalNote } from './screens/OptionalNote/OptionalNote';
import { Occupation } from './screens/Occupation/Occupation';
import { Location } from './screens/Location/Location';
import { Contact } from './screens/Contact/Contact';
import { Review } from './screens/Review/Review';
import { Confirmation } from './screens/Confirmation/Confirmation';
import './styles/global.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/for-whom" element={<WhoIsThisFor />} />
        <Route path="/help-type" element={<HelpTypeScreen />} />
        <Route path="/concerns" element={<ConcernsScreen />} />
        <Route path="/optional-note" element={<OptionalNote />} />
        <Route path="/occupation" element={<Occupation />} />
        <Route path="/location" element={<Location />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/review" element={<Review />} />
        <Route path="/confirmation" element={<Confirmation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
